import React from 'react';
import { useNavigate } from 'react-router-dom';
import './ServicePage.css';

function Cybersecurity() {
  const navigate = useNavigate();
  return (
    <div className="service-page">
      <header className="service-header">
        <h1>Cybersecurity & Threat Protection</h1>
        <p>Protect your business with proactive security measures and response services.</p>
      </header>
      <button className="back-button" onClick={() => navigate(-1)}>← Back</button>
      <div className="service-container">
        <section className="service-section">
          <h3>Offerings</h3>
          <ul>
            <li>Security audits & penetration testing</li>
            <li>Firewall and endpoint protection</li>
            <li>Monitoring, incident response & SOC services</li>
          </ul>
        </section>

        <div className="service-cta">
          <a href="/contact">Request a Security Assessment</a>
        </div>
      </div>
    </div>
  );
}

export default Cybersecurity;
